import React from "react";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import NumberFormat from "react-number-format";
import {Dropdown} from "primereact/dropdown";
import {Button} from "primereact/button";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import LinearProgress from "@material-ui/core/LinearProgress";
import {numberWithCommaDataTableTemplate} from "../../../utils/formatters/Numbers";
import HeaderScreenPresval from "../../../components/headerScreenPresval";

const ContingencyTrust = ({...props}) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        {props.messagesGrowl}
                        <HeaderScreenPresval headerTitle="Operación \ Contingencia Fideicomiso"
                                             onExpand={props.clearFilters}
                                             actionSearch={props.searchContingency}>
                            <Grid container direction="row" justify="space-evenly" alignItems="center">
                                <Grid item xs={3}>
                                    <label htmlFor="cb1" className="p-checkbox-label"><b>Folio</b></label>
                                    <NumberFormat
                                        name="folioFilter"
                                        thousandSeparator={false}
                                        placeholder="Ex. 1000"
                                        onChange={props.onChangeFilter}
                                        value={props.folioFilter}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <label htmlFor="cb1" className="p-checkbox-label"><b>Generación</b></label>
                                    <Dropdown
                                        name="statusContingencyFilter"
                                        filter={true}
                                        filterBy="description"
                                        options={props.catStatusContingencyTrust}
                                        optionLabel="description"
                                        showClear={true}
                                        placeholder="Seleccione..."
                                        onChange={props.onChangeFilter}
                                        value={props.statusContingencyFilter}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <label htmlFor="cb1" className="p-checkbox-label"><b>Contraparte</b></label>
                                    <Dropdown
                                        name="catInstitutionFilter"
                                        filter={true}
                                        filterBy="name"
                                        options={props.catInstitution}
                                        optionLabel="name"
                                        showClear={true}
                                        placeholder="Seleccione..."
                                        onChange={props.onChangeFilter}
                                        value={props.catInstitutionFilter}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <label htmlFor="cb1" className="p-checkbox-label"><b>Flujo</b></label>
                                    <Dropdown
                                        name="catLoanFlowFilter"
                                        filter={true}
                                        filterBy="name"
                                        options={props.catLoanFlow}
                                        optionLabel="name"
                                        showClear={true}
                                        placeholder="Seleccione..."
                                        onChange={props.onChangeFilter}
                                        value={props.catLoanFlowFilter}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <br/>
                                    <Button label="Limpiar"
                                            style={{'float': 'right'}}
                                            onClick={props.clearFilters}
                                            className="p-button-secondary"/>
                                </Grid>
                            </Grid>
                        </HeaderScreenPresval>
                    </Grid>

                    <Grid item xs={12}>
                        <DataTable
                            value={props.contingencyTrust}
                            header={props.headerContingencyTrust}
                            responsive={true}
                            selection={props.selectedInstruction}
                            onSelectionChange={props.selectRowInstruction}
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column selectionMode="multiple" style={{width: '3em'}}/>
                            <Column field="loanId" header="Folio" sortable={true}/>
                            <Column field="flow" header="Flujo" sortable={true}/>
                            <Column field="instrumentSerialName" header="Emisora" sortable={true}/>
                            <Column field="amount" header="Títulos" body={numberWithCommaDataTableTemplate}
                                    sortable={true}/>
                            <Column field="instructionSide" header="Tipo de Instrucción" sortable={true}/>
                            <Column field="origin" header="Origen" sortable={true}/>
                            <Column field="destiny" header="Destino" sortable={true}/>
                            <Column field="statusLoan" header="Estatus" sortable={true}/>
                            <Column field="statusContingencyTrust" header="Generación" sortable={true}/>
                            <Column field="user" header="Usuario" sortable={true}/>
                            <Column field="exportHour" header="Hora" sortable={true}/>
                        </DataTable>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default ContingencyTrust;